import React, { useMemo } from 'react';

import { useAuth } from 'contexts/AuthContext';

import { Role } from 'stores/AuthenticationStoreAdapter';

import TicketTypeSettings from './components/TicketTypeSettings';

/** グローバルチケット設定画面（ADMIN/BACK_OFFICE 操作可・全員参照可） */
const GlobalTicketTypeSettings: React.FC = () => {
  const { userSession } = useAuth();
  const canManageGlobal = useMemo(
    () => userSession.roles.some((r) => r === ('ADMIN' as Role) || r === ('BACK_OFFICE' as Role)),
    [userSession.roles],
  );

  return <TicketTypeSettings scope="GLOBAL" canManageGlobal={canManageGlobal} />;
};

export default GlobalTicketTypeSettings;
